import React from "react";
import "./Header.css";
import MenuButton from "./MenuButton.jsx";
import logoHeader from "../../Assets/logo-letrasrosadas-fondo-transparente.png";
import UserInfo from "./UserInfo";

const Header = (props) => {
  return (
    <div className="header sticky will-change-transform -top-[1px] left-0 shadow-[0px_0px_9px_1px_rgba(0,0,0,0.38)] bg-white z-[10000] h-[91px] w-full flex xl:justify-center ">
      <MenuButton />
      <div className=" xl:order-1 logo-container xl:mx-[20px] xl:w-[300px] justify-center max-w-[50%]">
        <img
          src="/images/Icons/logo-mariposa.png"
          alt="Mariposa Logo"
          className="header-image flex-grow"
        />
      </div>
      <UserInfo />
    </div>
  );
};

export default Header;
